import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Entrada suave (fade + subida) para los elementos con data-reveal que están bajo el pliegue.
export default function useReveal(deps = []) {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;
    const io = new IntersectionObserver((ents) => ents.forEach((en) => {
      if (!en.isIntersecting) return;
      const el = en.target;
      io.unobserve(el);
      el.style.opacity = '';
      el.animate(
        [{ opacity: 0, transform: 'translateY(28px)' }, { opacity: 1, transform: 'none' }],
        { duration: 850, easing: 'cubic-bezier(.2,.8,.2,1)', delay: Number(el.dataset.d) || 0 }
      );
    }), { rootMargin: '0px 0px -6% 0px' });
    const t = setTimeout(() => {
      let prevTop = -1, k = 0;
      document.querySelectorAll('[data-reveal]').forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.top > window.innerHeight * 0.92) {
          k = Math.abs(r.top - prevTop) < 4 ? k + 1 : 0;
          prevTop = r.top;
          el.dataset.d = String(Math.min(k, 5) * 70);
          el.style.opacity = '0';
          io.observe(el);
        }
      });
    }, 80);
    return () => { clearTimeout(t); io.disconnect(); document.querySelectorAll('[data-reveal]').forEach((el) => { el.style.opacity = ''; }); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, ...deps]);
}
